// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3oHF1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1ru52"};